/*
 * Adapted from: @ckeditor/ckeditor5-media-embed/src/mediaembedediting.js
 * The original implementation was copied and then customised to meet out specific needs
 */
export default {
	name: 'vimeo',
	url: [
		/^vimeo\.com\/(\d+)/,
		/^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/,
		/^vimeo\.com\/album\/[^/]+\/video\/(\d+)/,
		/^vimeo\.com\/channels\/[^/]+\/(\d+)/,
		/^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/,
		/^vimeo\.com\/ondemand\/[^/]+\/(\d+)/,
		/^player\.vimeo\.com\/video\/(\d+)/,
	],
	html: (match: RegExpMatchArray) => {
		const id = match[1];

		return (
			`<iframe src="https://player.vimeo.com/video/${id}" aria-label="video" ` +
			'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>' +
			'</iframe>'
		);
	},
};
